export const data = [
  {
    "Title": "Abbott and Costello",
    "Issue #": 18,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "St John",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Abbott and Costello",
    "Issue #": 19,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "St John",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure into Mystery",
    "Issue #": 8,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 30,
    "": "Trade"
  },
  {
    "Title": "Adventures in 3-D",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "w/glasses",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Adventures into Darkness",
    "Issue #": 5,
    "Condition": "GD ",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Standard",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Adventures into Darkness",
    "Issue #": 11,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Standard",
    "Cost Basis": 500,
    "": ""
  },
  {
    "Title": "Adventures into Terror",
    "Issue #": 9,
    "Condition": "FN",
    "Website Notes": "Classic Heath Cvr",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 175,
    "": ""
  },
  {
    "Title": "Adventures into Terror",
    "Issue #": 22,
    "Condition": "GD",
    "Website Notes": "Maneely Heath",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 90,
    "": "TTreasures"
  },
  {
    "Title": "Adventures into Terror",
    "Issue #": 23,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 100,
    "": "TTreasures"
  },
  {
    "Title": "Adventures into Terror",
    "Issue #": 29,
    "Condition": "GD",
    "Website Notes": "Maneely",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Adventures into the Unknown",
    "Issue #": 8,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 30,
    "": "Joe"
  },
  {
    "Title": "Adventures into the Unknown",
    "Issue #": 14,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Adventures into the Unknown",
    "Issue #": 45,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 50,
    "": "Brian trade"
  },
  {
    "Title": "Adventures into the Unknown",
    "Issue #": 61,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Adventures of Mighty Mouse",
    "Issue #": 128,
    "Condition": "VG",
    "Website Notes": 1957,
    "Personal Notes (Not on website)": "Pines",
    "Cost Basis": 5,
    "": "Gilligans"
  },
  {
    "Title": "Adventures of Robin Hood",
    "Issue #": 8,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ME",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Airboy Comics",
    "Issue #": "V5 #7",
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 27,
    "": ""
  },
  {
    "Title": "Airboy Comics",
    "Issue #": "V7#12",
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Airboy Comics",
    "Issue #": "V8 #2",
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 27,
    "": ""
  },
  {
    "Title": "Airboy Comics",
    "Issue #": "V8 #6",
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 27,
    "": ""
  },
  {
    "Title": "Air Fighters",
    "Issue #": 8,
    "Condition": "CGC 3.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 250,
    "": "Tim"
  },
  {
    "Title": "Alley Oop",
    "Issue #": 11,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Standard",
    "Cost Basis": 18,
    "": ""
  },
  {
    "Title": "Alley Oop",
    "Issue #": 13,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Standard",
    "Cost Basis": 18,
    "": ""
  },
  {
    "Title": "Alley Oop",
    "Issue #": 17,
    "Condition": "VG",
    "Website Notes": "Schomburg",
    "Personal Notes (Not on website)": "Standard",
    "Cost Basis": 18,
    "": ""
  },
  {
    "Title": "All New Comics",
    "Issue #": 14,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 75,
    "": "Dahlgren"
  },
  {
    "Title": "All Top",
    "Issue #": 14,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fox",
    "Cost Basis": 185,
    "": ""
  },
  {
    "Title": "All True Crime",
    "Issue #": 27,
    "Condition": "G/VG",
    "Website Notes": "Electric Chair Cvr",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 35,
    "": "Rich G"
  },
  {
    "Title": "All True Crime",
    "Issue #": 28,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "All True Crime",
    "Issue #": 42,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Amazing Comics",
    "Issue #": 1,
    "Condition": "CGC 3.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Timely",
    "Cost Basis": 965,
    "": "Hakes"
  },
  {
    "Title": "Amazing Detective Cases",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": "Rich G"
  },
  {
    "Title": "Amazing Detective Cases",
    "Issue #": 7,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 55,
    "": "30th Century"
  },
  {
    "Title": "Amazing Detective Cases",
    "Issue #": 8,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 55,
    "": "30th Century"
  },
  {
    "Title": "American Eagle",
    "Issue #": "V24 #3",
    "Condition": "FN",
    "Website Notes": "Pulp",
    "Personal Notes (Not on website)": "Thrilling",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Apache Kid",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Arrowhead",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 30,
    "": "Tim"
  },
  {
    "Title": "Astonishing",
    "Issue #": 29,
    "Condition": "VG+",
    "Website Notes": "Everett",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 200,
    "": "30th Century"
  },
  {
    "Title": "Astonishing",
    "Issue #": 51,
    "Condition": "GD",
    "Website Notes": "Everett",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": "30th Century"
  },
  {
    "Title": "Astonishing",
    "Issue #": 61,
    "Condition": "VG/F",
    "Website Notes": "Everett",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 50,
    "": "AHeroes"
  },
  {
    "Title": "Astonishing",
    "Issue #": 62,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 50,
    "": "AHeroes"
  },
  {
    "Title": "Atomic Attack",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "A-Bomb Story",
    "Personal Notes (Not on website)": "Youthful",
    "Cost Basis": 56,
    "": ""
  },
  {
    "Title": "Atomic Bomb",
    "Issue #": 1,
    "Condition": "F+",
    "Website Notes": "Rare",
    "Personal Notes (Not on website)": "Jay Burtis",
    "Cost Basis": 300,
    "": ""
  },
  {
    "Title": "Atomic Comics",
    "Issue #": 4,
    "Condition": "FN+",
    "Website Notes": "Kamen Baker GGA",
    "Personal Notes (Not on website)": "Green",
    "Cost Basis": 700,
    "": ""
  },
  {
    "Title": "Attack on Planet Mars",
    "Issue #": "NN",
    "Condition": "FA",
    "Website Notes": "Wood Art 1951",
    "Personal Notes (Not on website)": "Avon",
    "Cost Basis": 30,
    "": "Gilligans"
  },
  {
    "Title": "Authentic Police Cases",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "Bondage Cover",
    "Personal Notes (Not on website)": "St John 2 avail",
    "Cost Basis": 76,
    "": ""
  },
  {
    "Title": "Authentic Police Cases",
    "Issue #": 1,
    "Condition": "G",
    "Website Notes": "Bondage Cover",
    "Personal Notes (Not on website)": "St John",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Babe Ruth Sports",
    "Issue #": 9,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Baffling Mysteries",
    "Issue #": 10,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Ace",
    "Cost Basis": 40,
    "": "Rich G"
  },
  {
    "Title": "Baffling Mysteries",
    "Issue #": 13,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Ace",
    "Cost Basis": 75,
    "": "Rich G"
  },
  {
    "Title": "Baseball Heroes",
    "Issue #": "NN",
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Baseball Thrills",
    "Issue #": 3,
    "Condition": "G/VG",
    "Website Notes": "Dimaggio Story",
    "Personal Notes (Not on website)": "Ziff Davis",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Battle ",
    "Issue #": 18,
    "Condition": "VG/F",
    "Website Notes": "Heath Flamethrower C",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 100,
    "": "Tomlinson"
  },
  {
    "Title": "Battle ",
    "Issue #": 35,
    "Condition": "VG/F",
    "Website Notes": "Heath Flamethrower C",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Battlefield",
    "Issue #": 6,
    "Condition": "G/VG",
    "Website Notes": "Flamethrower Cover",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Battlefield",
    "Issue #": 9,
    "Condition": "VG/F",
    "Website Notes": "Heath Cover",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 30,
    "": "Tomlinson"
  },
  {
    "Title": "Battlefield",
    "Issue #": 9,
    "Condition": "VG",
    "Website Notes": "Heath Cover",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Battlefront",
    "Issue #": 31,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Battle Stories",
    "Issue #": 8,
    "Condition": "G/VG",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 25,
    "": "George"
  },
  {
    "Title": "Beware",
    "Issue #": 14,
    "Condition": "CGC 1.8",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Beyond",
    "Issue #": 8,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Ace",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Bible",
    "Issue #": 5,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Billy West",
    "Issue #": 7,
    "Condition": "G",
    "Website Notes": "Schomburg",
    "Personal Notes (Not on website)": "Standard",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 5,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 6,
    "Condition": "FA",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 8,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 150,
    "": "Gilligans"
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 17,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 18,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 19,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 21,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 22,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 30,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 55,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 55,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 55,
    "Condition": "FA",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 55,
    "Condition": "P/F",
    "Website Notes": "3/4 Cover",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 56,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 56,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 59,
    "Condition": "FN",
    "Website Notes": "Kirby Art",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 50,
    "": "Brian"
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 59,
    "Condition": "FN",
    "Website Notes": "Kirby Art",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 61,
    "Condition": "FN+",
    "Website Notes": "Simon Cvr",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 63,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 63,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 64,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Black Cat Comics",
    "Issue #": 65,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Blackhawk",
    "Issue #": 35,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Blackhawk",
    "Issue #": 96,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 35,
    "": "Dahlgren"
  },
  {
    "Title": "Black Hood Comics",
    "Issue #": 14,
    "Condition": "VG/F",
    "Website Notes": "Kinstler Blood Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 170,
    "": "Gilligans"
  },
  {
    "Title": "Black Knight",
    "Issue #": 1,
    "Condition": "CGC 2.5",
    "Website Notes": " ",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 1600,
    "": "Mike"
  },
  {
    "Title": "Black Knight",
    "Issue #": 5,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 50,
    "": "Kent ref"
  },
  {
    "Title": "Black Magic",
    "Issue #": 17,
    "Condition": "CGC 3.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Prize",
    "Cost Basis": 112,
    "": ""
  },
  {
    "Title": "Black Magic",
    "Issue #": "V2 #1",
    "Condition": "VG",
    "Website Notes": "S&K Art",
    "Personal Notes (Not on website)": "Prize",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Black Magic",
    "Issue #": "V8#5",
    "Condition": "F/VF",
    "Website Notes": "EC Swipe Last Iss",
    "Personal Notes (Not on website)": "Prize",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Blackstone Master Magician",
    "Issue #": 3,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Vital",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Black Terror",
    "Issue #": 25,
    "Condition": "P",
    "Website Notes": "Coverless",
    "Personal Notes (Not on website)": "Better",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Blue Bolt",
    "Issue #": "V5#7",
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Dahlgren"
  },
  {
    "Title": "Blue Bolt",
    "Issue #": "V8#5",
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Boy Comics",
    "Issue #": 29,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Boy Comics",
    "Issue #": 33,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Boy Comics",
    "Issue #": 36,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Boy Comics",
    "Issue #": 38,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Boy Comics",
    "Issue #": 46,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Boy Comics",
    "Issue #": 49,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Boy Comics",
    "Issue #": 108,
    "Condition": "VG",
    "Website Notes": "Kubert Ditko",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Brain",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ME",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Broncho Bill",
    "Issue #": 6,
    "Condition": "VG-",
    "Website Notes": "Schomburg",
    "Personal Notes (Not on website)": "United Features",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Broncho Bill",
    "Issue #": 8,
    "Condition": "VG",
    "Website Notes": "Schomburg",
    "Personal Notes (Not on website)": "United Features",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Buffalo Bill",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "Bondage Cvr",
    "Personal Notes (Not on website)": "Youthful",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Buffalo Bill",
    "Issue #": 9,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Youthful",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Bughouse",
    "Issue #": 4,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Farrell",
    "Cost Basis": 10,
    "": "Charlottesvile"
  },
  {
    "Title": "Bulls Eye",
    "Issue #": 3,
    "Condition": "GD",
    "Website Notes": "Simon Kirby",
    "Personal Notes (Not on website)": "Mainline",
    "Cost Basis": 25,
    "": "Gilligans"
  },
  {
    "Title": "Bulls Eye",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "Simon Kirby",
    "Personal Notes (Not on website)": "Mainline",
    "Cost Basis": 75,
    "": "Dahlgren"
  },
  {
    "Title": "Camp Comics",
    "Issue #": 2,
    "Condition": "G",
    "Website Notes": "Kelly Art Classic Cover",
    "Personal Notes (Not on website)": "Dell",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Candy",
    "Issue #": 50,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Captain Easy",
    "Issue #": 12,
    "Condition": "G",
    "Website Notes": "GGA",
    "Personal Notes (Not on website)": "Standard",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Captain Easy",
    "Issue #": 13,
    "Condition": "G/VG",
    "Website Notes": "Schomburg",
    "Personal Notes (Not on website)": "Standard",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Captain Flight",
    "Issue #": 6,
    "Condition": "VG",
    "Website Notes": "Scarce",
    "Personal Notes (Not on website)": "Four Star",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Captain Marvel Adventures",
    "Issue #": 24,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Captain Marvel Adventures",
    "Issue #": 88,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Captain Marvel Adventures",
    "Issue #": 136,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Captain Marvel Jr",
    "Issue #": 12,
    "Condition": "FA",
    "Website Notes": "Raboy Cvr",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 50,
    "": "Todd"
  },
  {
    "Title": "Captain Marvel Jr",
    "Issue #": 18,
    "Condition": "CGC 4.0",
    "Website Notes": "Raboy Cvr",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 140,
    "": "Matt"
  },
  {
    "Title": "Captain Marvel Jr",
    "Issue #": 67,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Captain Marvel Jr",
    "Issue #": 72,
    "Condition": "P",
    "Website Notes": "Coverless",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Captain Science",
    "Issue #": 4,
    "Condition": "FA",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Aragon",
    "Cost Basis": 35,
    "": "AHeroes"
  },
  {
    "Title": "Captain 3-D",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "w/glasses",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 15,
    "": "gilligans"
  },
  {
    "Title": "Captain Video",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Captain Video",
    "Issue #": 2,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Cave Girl",
    "Issue #": 12,
    "Condition": "G",
    "Website Notes": "Powell Art",
    "Personal Notes (Not on website)": "ME",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Cave Girl",
    "Issue #": 13,
    "Condition": "G/VG",
    "Website Notes": "Bondage Panels",
    "Personal Notes (Not on website)": "ME",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Chamber of Chills",
    "Issue #": 24,
    "Condition": "VG",
    "Website Notes": "Bondage Cover",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Chamber of Chills",
    "Issue #": 26,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 125,
    "": "Joe"
  },
  {
    "Title": "Classic Comics",
    "Issue #": 16,
    "Condition": "G/VG",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Classic Comics",
    "Issue #": 26,
    "Condition": "VG-",
    "Website Notes": "HRN 71",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Classics Illustrated",
    "Issue #": 26,
    "Condition": "G+",
    "Website Notes": "HRN117",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 5,
    "": "Mike"
  },
  {
    "Title": "Classic Comics",
    "Issue #": 27,
    "Condition": "VG+",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Classic Comics",
    "Issue #": 29,
    "Condition": "G/VG",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Classics Illustrated",
    "Issue #": 32,
    "Condition": "FN+",
    "Website Notes": "HRN64",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 10,
    "": "Joe"
  },
  {
    "Title": "Classic Comics",
    "Issue #": 34,
    "Condition": "FN",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 20,
    "": "Joe"
  },
  {
    "Title": "Classic Comics",
    "Issue #": 40,
    "Condition": "VG",
    "Website Notes": "HRN 92",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Classic Comics",
    "Issue #": 61,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Classic Comics",
    "Issue #": 62,
    "Condition": "VG/F",
    "Website Notes": "HRN 89",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Classic Comics",
    "Issue #": 72,
    "Condition": "FN-",
    "Website Notes": "HRN 89",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Classics Illustrated",
    "Issue #": 73,
    "Condition": "FN-",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Classics Illustrated",
    "Issue #": 85,
    "Condition": "G-",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Classics Illustrated",
    "Issue #": 87,
    "Condition": "VG",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Classics Illustrated",
    "Issue #": 95,
    "Condition": "FN",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Classics Illustrated",
    "Issue #": 100,
    "Condition": "G/VG",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Classics Illustrated",
    "Issue #": 117,
    "Condition": "VG",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Classics Illustrated",
    "Issue #": 149,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 5,
    "": "Mike"
  },
  {
    "Title": "Classics Illustrated",
    "Issue #": 160,
    "Condition": "FN+",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 5,
    "": "Mike"
  },
  {
    "Title": "Classics Illustrated",
    "Issue #": 160,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Classics Illustrated",
    "Issue #": 162,
    "Condition": "G/VG",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 5,
    "": "Mike"
  },
  {
    "Title": "Classics Illustrated",
    "Issue #": 163,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Classics",
    "Cost Basis": 5,
    "": "Mike"
  },
  {
    "Title": "Clue Comics",
    "Issue #": "V2#3",
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 80,
    "": "Trade"
  },
  {
    "Title": "Combat",
    "Issue #": 4,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Combat",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "Heath Cvr",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 40,
    "": "Wulf"
  },
  {
    "Title": "Combat Kelly",
    "Issue #": 20,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 50,
    "": "30th Century"
  },
  {
    "Title": "Comic Land",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fact & Fiction",
    "Cost Basis": 40,
    "": "Gilligans"
  },
  {
    "Title": "Comic Land",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fact & Fiction",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Complete Book of True Crime Comics",
    "Issue #": 1,
    "Condition": "CGC 3.5",
    "Website Notes": "132 pages",
    "Personal Notes (Not on website)": "Wise Pub",
    "Cost Basis": 280,
    "": "Pedigree"
  },
  {
    "Title": "Contact Comics",
    "Issue #": 8,
    "Condition": "VG",
    "Website Notes": "LB Cole",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 130,
    "": ""
  },
  {
    "Title": "Cool Cat",
    "Issue #": "NN",
    "Condition": "FN",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "Prize",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Cowgirl Romances",
    "Issue #": 6,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 250,
    "": ""
  },
  {
    "Title": "Cow Puncher",
    "Issue #": 5,
    "Condition": "GD",
    "Website Notes": "GGA",
    "Personal Notes (Not on website)": "Avon",
    "Cost Basis": 75,
    "": "Trade"
  },
  {
    "Title": "Crack Comics",
    "Issue #": 60,
    "Condition": "VG",
    "Website Notes": "Hanging Cover",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Crime and Punishment",
    "Issue #": 2,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Crime and Punishment",
    "Issue #": 3,
    "Condition": "GD",
    "Website Notes": "Used in SOTI",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Crime and Punishment",
    "Issue #": 4,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Crime and Punishment",
    "Issue #": 17,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Crime and Punishment",
    "Issue #": 33,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Crime and Punishment",
    "Issue #": 54,
    "Condition": "VG",
    "Website Notes": "Electric Chair C/S",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Crime Cases Private Eye",
    "Issue #": 3,
    "Condition": "FA",
    "Website Notes": "CF Missing",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Crime Clinic",
    "Issue #": 3,
    "Condition": "GD",
    "Website Notes": "Saunders Cvr",
    "Personal Notes (Not on website)": "Ziff Davis",
    "Cost Basis": 50,
    "": "Rich G"
  },
  {
    "Title": "Crime Detective Comics",
    "Issue #": "V1#8",
    "Condition": "FN",
    "Website Notes": "Double Cover",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 40,
    "": "Gilligans"
  },
  {
    "Title": "Crime Detective Comics",
    "Issue #": "V3#8",
    "Condition": "F/G",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 10,
    "": "Gilligans"
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 49,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 50,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 53,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 54,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 55,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 56,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 58,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 59,
    "Condition": "VG-",
    "Website Notes": "Buried Alive Cover",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 62,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 65,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 67,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 75,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 105,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 111,
    "Condition": "GD",
    "Website Notes": "Used in POP",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 132,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 20,
    "": "Rich G"
  },
  {
    "Title": "Crime Does Not Pay",
    "Issue #": 145,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Crime Exposed",
    "Issue #": 1,
    "Condition": "CGC 7.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 300,
    "": ""
  },
  {
    "Title": "Crime Exposed",
    "Issue #": 8,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": "Rich G"
  },
  {
    "Title": "Crime Fighters",
    "Issue #": 6,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Timely",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Crime Files",
    "Issue #": 6,
    "Condition": "G",
    "Website Notes": "Sekowsky Art",
    "Personal Notes (Not on website)": "Standard",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Crime Must Lose",
    "Issue #": 12,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 50,
    "": "30th Century"
  },
  {
    "Title": "Crime Must Pay the Penalty",
    "Issue #": 18,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Ace",
    "Cost Basis": 25,
    "": "Rich G"
  },
  {
    "Title": "Crime Must Pay the Penalty",
    "Issue #": 30,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Ace",
    "Cost Basis": 35,
    "": "Rich G"
  },
  {
    "Title": "Crime Must Pay the Penalty",
    "Issue #": 31,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Ace",
    "Cost Basis": 35,
    "": "Rich G"
  },
  {
    "Title": "Crime Must Pay the Penalty",
    "Issue #": 36,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Ace",
    "Cost Basis": 35,
    "": "Rich G"
  },
  {
    "Title": "Crime Smashers",
    "Issue #": 1,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Trojan",
    "Cost Basis": 100,
    "": "Beyond"
  },
  {
    "Title": "Crime Smashers",
    "Issue #": 13,
    "Condition": "G",
    "Website Notes": "Used in POP",
    "Personal Notes (Not on website)": "Trojan",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Dagwood Comics",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": 1950,
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Danger",
    "Issue #": 10,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Comic Media",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Danger",
    "Issue #": 10,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Comic Media",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Daredevil Comics",
    "Issue #": 41,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Daredevil Comics",
    "Issue #": 42,
    "Condition": "F/VF",
    "Website Notes": "Intro Kilroy",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Daredevil Comics",
    "Issue #": 59,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Daredevil Comics",
    "Issue #": 79,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Dead-Eye Western",
    "Issue #": "V1#2",
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 5,
    "": "Vince"
  },
  {
    "Title": "Debbie Dean Career Girl",
    "Issue #": 2,
    "Condition": "CGC 4.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Civil Service",
    "Cost Basis": 75,
    "": "30th Century"
  },
  {
    "Title": "Desperado",
    "Issue #": 2,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Desperado",
    "Issue #": 3,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Dick Tracy",
    "Issue #": 95,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Dick Tracy",
    "Issue #": 97,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Dick Tracy",
    "Issue #": "NN",
    "Condition": "F/VF",
    "Website Notes": "Popped Wheat Giveaway",
    "Personal Notes (Not on website)": "Tribune",
    "Cost Basis": 5,
    "": "Frederick"
  },
  {
    "Title": "Don Fortune",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "CC Beck Art",
    "Personal Notes (Not on website)": "Don Fortune",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Don Winslow",
    "Issue #": 38,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Dream Book of Romance",
    "Issue #": 8,
    "Condition": "VG",
    "Website Notes": "Photo Cover Powell",
    "Personal Notes (Not on website)": "ME",
    "Cost Basis": 10,
    "": "Charlottesville"
  },
  {
    "Title": "Durango Kid",
    "Issue #": 35,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ME",
    "Cost Basis": 6,
    "": "edmonton"
  },
  {
    "Title": "Eerire",
    "Issue #": 4,
    "Condition": "G/VG",
    "Website Notes": "Wood Cvr",
    "Personal Notes (Not on website)": "Avon",
    "Cost Basis": 160,
    "": ""
  },
  {
    "Title": "Eerire",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "Wood Cvr",
    "Personal Notes (Not on website)": "Avon",
    "Cost Basis": 300,
    "": "30th Century"
  },
  {
    "Title": "Eerire",
    "Issue #": 12,
    "Condition": "G/VG",
    "Website Notes": "Dracula C/S",
    "Personal Notes (Not on website)": "Avon",
    "Cost Basis": 200,
    "": "30th Century"
  },
  {
    "Title": "Etta Kett",
    "Issue #": 11,
    "Condition": "FN+",
    "Website Notes": "1st Issue",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Exposed",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "Crime",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Family Favourites",
    "Issue #": 12,
    "Condition": "G/VG",
    "Website Notes": "British",
    "Personal Notes (Not on website)": "L. Miller",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Famous Funnies",
    "Issue #": 216,
    "Condition": "CGC 4.0",
    "Website Notes": "Frazetta Cvr",
    "Personal Notes (Not on website)": "Eastern",
    "Cost Basis": 690,
    "": "lonestar"
  },
  {
    "Title": "Fantastic  ",
    "Issue #": 8,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Youthful",
    "Cost Basis": 135,
    "": ""
  },
  {
    "Title": "Fantastic",
    "Issue #": 11,
    "Condition": "VG",
    "Website Notes": "Robot Cvr",
    "Personal Notes (Not on website)": "Farrell",
    "Cost Basis": 450,
    "": "Basement"
  },
  {
    "Title": "Fantastic Fears",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": 1954,
    "Personal Notes (Not on website)": "Farrell",
    "Cost Basis": 200,
    "": "TTreasures"
  },
  {
    "Title": "Fantastic Novels",
    "Issue #": "7/48",
    "Condition": "VG/F",
    "Website Notes": "Pulp",
    "Personal Notes (Not on website)": "Pulp",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Fantastic Worlds",
    "Issue #": 6,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Standard",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Feature Books",
    "Issue #": 36,
    "Condition": "G",
    "Website Notes": "Centerfold Missing",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Fight Against Crime",
    "Issue #": 18,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Story",
    "Cost Basis": 400,
    "": "Gilligans"
  },
  {
    "Title": "Fight Comics",
    "Issue #": 10,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Fight Comics",
    "Issue #": 25,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Fight Comics",
    "Issue #": 48,
    "Condition": "VG",
    "Website Notes": " ",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 100,
    "": "Chris Frohwirth"
  },
  {
    "Title": "Fight Comics",
    "Issue #": 63,
    "Condition": "VG-",
    "Website Notes": "Baker Art",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 50,
    "": "Gilligans"
  },
  {
    "Title": "Fight Comics",
    "Issue #": 78,
    "Condition": "VG+",
    "Website Notes": "Canadian",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 50,
    "": "BCC"
  },
  {
    "Title": "Feature Stories Magazine",
    "Issue #": 3,
    "Condition": "VG",
    "Website Notes": "Bondage Cover",
    "Personal Notes (Not on website)": "Fox",
    "Cost Basis": 285,
    "": ""
  },
  {
    "Title": "Fighting American",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 21,
    "": ""
  },
  {
    "Title": "Fighting Fronts!",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 30,
    "": 2006
  },
  {
    "Title": "Fighting Man",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Farrell",
    "Cost Basis": 20,
    "": "George"
  },
  {
    "Title": "Fighting Yank",
    "Issue #": 9,
    "Condition": "GD",
    "Website Notes": "Schomburg",
    "Personal Notes (Not on website)": "Nedor",
    "Cost Basis": 300,
    "": "30th Century"
  },
  {
    "Title": "Firehair",
    "Issue #": 10,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 60,
    "": "Holder"
  },
  {
    "Title": "First Love Illustrated",
    "Issue #": 39,
    "Condition": "VG",
    "Website Notes": "Powell Art",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 10,
    "": "Roanoke"
  },
  {
    "Title": "Flash Gordon",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "Bondage Cover",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Flash Gordon",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Flash Gordon",
    "Issue #": 3,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Flash Gordon",
    "Issue #": 4,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Forbidden Worlds",
    "Issue #": 22,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Forbidden Worlds",
    "Issue #": 62,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 15,
    "": "GA Collectibles"
  },
  {
    "Title": "Frankenstein",
    "Issue #": 33,
    "Condition": "VG",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "Prize",
    "Cost Basis": 150,
    "": ""
  },
  {
    "Title": "Funny Picture Stories",
    "Issue #": "V2#2",
    "Condition": "VG/F",
    "Website Notes": "Rare",
    "Personal Notes (Not on website)": "Centaur",
    "Cost Basis": 400,
    "": "30th Century"
  },
  {
    "Title": "Gabby",
    "Issue #": 2,
    "Condition": "GD",
    "Website Notes": "Centerfold Missing",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Ghost Comics",
    "Issue #": 6,
    "Condition": "CGC 2.0",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 500,
    "": ""
  },
  {
    "Title": "Ghost Rider",
    "Issue #": 13,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ME",
    "Cost Basis": 20,
    "": "beyond"
  },
  {
    "Title": "Giants",
    "Issue #": "NN",
    "Condition": "FN",
    "Website Notes": "Baseball 1952",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 168,
    "": ""
  },
  {
    "Title": "GI Combat",
    "Issue #": 30,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "GI Combat",
    "Issue #": 39,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Giggle Comics",
    "Issue #": 31,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 5,
    "": "Vince"
  },
  {
    "Title": "Giggle Comics",
    "Issue #": 67,
    "Condition": "VG",
    "Website Notes": "Ghost Cvr",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 5,
    "": "gilligans"
  },
  {
    "Title": "GI in Battle",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": 1957,
    "Personal Notes (Not on website)": "Ajax",
    "Cost Basis": 20,
    "": "George"
  },
  {
    "Title": "GI Joe",
    "Issue #": 19,
    "Condition": "VG",
    "Website Notes": "Flamethrower Cvr",
    "Personal Notes (Not on website)": "Ziff-Davis",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Grand Slam",
    "Issue #": 52,
    "Condition": "F/G",
    "Website Notes": "3/4 Cover",
    "Personal Notes (Not on website)": "Canadian",
    "Cost Basis": 28,
    "": ""
  },
  {
    "Title": "Great Western",
    "Issue #": 9,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ME",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Green Hornet Comics",
    "Issue #": 24,
    "Condition": "P/F",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 40,
    "": "CConnect"
  },
  {
    "Title": "Green Mask",
    "Issue #": "V2#4",
    "Condition": "CGC 9.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fox",
    "Cost Basis": 150,
    "": "BCC2024"
  },
  {
    "Title": "Guadalcanal Diary",
    "Issue #": "",
    "Condition": "VG/F",
    "Website Notes": "One Shot 1943",
    "Personal Notes (Not on website)": "American Library",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Gunsmoke",
    "Issue #": 3,
    "Condition": "VG",
    "Website Notes": "Bondage Cvr",
    "Personal Notes (Not on website)": "Western Comics",
    "Cost Basis": 160,
    "": "Heritage"
  },
  {
    "Title": "Gunsmoke Western",
    "Issue #": 38,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Gunsmoke Western",
    "Issue #": 44,
    "Condition": "VG",
    "Website Notes": "Torres Art",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Gunsmoke Western",
    "Issue #": 45,
    "Condition": "VG",
    "Website Notes": "Maneely",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Gunsmoke Western",
    "Issue #": 59,
    "Condition": "FN",
    "Website Notes": "Kirby",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Gunsmoke Western",
    "Issue #": 74,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Gunsmoke Western",
    "Issue #": 57,
    "Condition": "VG",
    "Website Notes": "1st Two Gun Kid",
    "Personal Notes (Not on website)": "Atlas ",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Gunsmoke Western",
    "Issue #": 77,
    "Condition": "FN",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Haunted Thrills",
    "Issue #": 16,
    "Condition": "GD",
    "Website Notes": "Scarce",
    "Personal Notes (Not on website)": "Farrell",
    "Cost Basis": 200,
    "": "Heritage"
  },
  {
    "Title": "Haunted Thrills",
    "Issue #": 17,
    "Condition": "CGC 5.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Farrell",
    "Cost Basis": 275,
    "": "comiclink"
  },
  {
    "Title": "Headline Comics",
    "Issue #": 29,
    "Condition": "G/VG",
    "Website Notes": "S&K",
    "Personal Notes (Not on website)": "Prize",
    "Cost Basis": 25,
    "": "Gilligans"
  },
  {
    "Title": "Heroic Comics",
    "Issue #": 30,
    "Condition": "VG",
    "Website Notes": "D-Day Story",
    "Personal Notes (Not on website)": "Famous Funnies",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Heroic Comics",
    "Issue #": 91,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Famous Funnies",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Hit Comics",
    "Issue #": 12,
    "Condition": "G/VG",
    "Website Notes": "Lou Fine Cvr",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 100,
    "": "Gilligans"
  },
  {
    "Title": "Home Run",
    "Issue #": 3,
    "Condition": "VG-",
    "Website Notes": "Stan Musial Cvr",
    "Personal Notes (Not on website)": "ME",
    "Cost Basis": 10,
    "": "Gilligans"
  },
  {
    "Title": "Hot Rod and Speedway Comics",
    "Issue #": 5,
    "Condition": "FN",
    "Website Notes": "Last Issue Scarce",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 25,
    "": "Gilligans"
  },
  {
    "Title": "Hot Rod Comics",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Hot Rod Comics",
    "Issue #": 7,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Inside Crime",
    "Issue #": "nn",
    "Condition": "VG/F",
    "Website Notes": "Wood Cvr",
    "Personal Notes (Not on website)": "Story",
    "Cost Basis": 25,
    "": "Vince"
  },
  {
    "Title": "Jack Armstrong",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "Boxing Cover",
    "Personal Notes (Not on website)": "Smith",
    "Cost Basis": 20,
    "": "Gilligans"
  },
  {
    "Title": "Jackie Robinson",
    "Issue #": 4,
    "Condition": "G+",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 70,
    "": ""
  },
  {
    "Title": "Jet",
    "Issue #": 1,
    "Condition": "GD",
    "Website Notes": "Powell Art",
    "Personal Notes (Not on website)": "ME",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Joe Palooka",
    "Issue #": 51,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 5,
    "": "gilligans"
  },
  {
    "Title": "Joe Yank",
    "Issue #": 10,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Standard",
    "Cost Basis": 10,
    "": "GA Collectibles"
  },
  {
    "Title": "Johnson Makes the Team",
    "Issue #": "NN",
    "Condition": "VG",
    "Website Notes": "1950 Giveaway",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "John Wayne Comics",
    "Issue #": 3,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Toby",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Johnny Law Sky Ranger",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "Scarce",
    "Personal Notes (Not on website)": "Good",
    "Cost Basis": 40,
    "": "Brian"
  },
  {
    "Title": "Journey into Fear",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Superior",
    "Cost Basis": 250,
    "": ""
  },
  {
    "Title": "Journey into Fear",
    "Issue #": 15,
    "Condition": "CGC 2.0",
    "Website Notes": "SOTI",
    "Personal Notes (Not on website)": "Superior",
    "Cost Basis": 110,
    "": "30th Century"
  },
  {
    "Title": "Journey into Fear",
    "Issue #": 20,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Superior",
    "Cost Basis": 150,
    "": "Brian"
  },
  {
    "Title": "Journey Into Unknown Worlds",
    "Issue #": 59,
    "Condition": "VG",
    "Website Notes": "Everett Last Iss",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Jumbo Comics",
    "Issue #": 20,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 100,
    "": "Mike"
  },
  {
    "Title": "Jumbo Comics",
    "Issue #": 126,
    "Condition": "FA",
    "Website Notes": "CF Missing",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 5,
    "": "Frederick"
  },
  {
    "Title": "Jumbo Comics",
    "Issue #": 151,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 94,
    "": "30th Century"
  },
  {
    "Title": "Jumbo Comics",
    "Issue #": 152,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 50,
    "": "30th Century"
  },
  {
    "Title": "Jumbo Comics",
    "Issue #": 166,
    "Condition": "VG/F",
    "Website Notes": "Horror Cvr",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 150,
    "": "MyComicShop"
  },
  {
    "Title": "Jungle Action",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Jungle Comics",
    "Issue #": 54,
    "Condition": "FA",
    "Website Notes": "Bondage Cvr/CFM",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 50,
    "": "Todd"
  },
  {
    "Title": "Jungle Comics",
    "Issue #": 85,
    "Condition": "F/VF",
    "Website Notes": "Bondage Cvr",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Jungle Comics",
    "Issue #": 109,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 35,
    "": " "
  },
  {
    "Title": "Jungle Comics",
    "Issue #": 114,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Jungle Comics",
    "Issue #": 116,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Jungle Comics",
    "Issue #": 121,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Jungle Comics",
    "Issue #": 149,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Jungle Comics",
    "Issue #": 150,
    "Condition": "VG",
    "Website Notes": "Bondage Cover",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Jungle Comics",
    "Issue #": 157,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Jungle Comics",
    "Issue #": 158,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Jungle Comics",
    "Issue #": 160,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Jungle Comics",
    "Issue #": 163,
    "Condition": "VG-",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Jungle Girl",
    "Issue #": 1,
    "Condition": "GD",
    "Website Notes": "Nyoka",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Justice Traps the Guilty",
    "Issue #": 10,
    "Condition": "G",
    "Website Notes": "Centerfold Missing",
    "Personal Notes (Not on website)": "Prize",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice Traps the Guilty",
    "Issue #": 31,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Prize",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice Traps the Guilty",
    "Issue #": 89,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Prize",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Kaanga",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Kaanga",
    "Issue #": 2,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Kaanga",
    "Issue #": 5,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Kaanga",
    "Issue #": 13,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Kaanga",
    "Issue #": 16,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Kaanga",
    "Issue #": 20,
    "Condition": "VG",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 25,
    "": "2 avail Dahlgren"
  },
  {
    "Title": "Kathy",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Scarce",
    "Personal Notes (Not on website)": "Marvel",
    "Cost Basis": 100,
    "": "30th Century"
  },
  {
    "Title": "Ken Shannon",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Ken Shannon",
    "Issue #": 10,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Kent Blake of the Secret Service",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Kent Blake of the Secret Service",
    "Issue #": 9,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Kerry Drake Detective cases",
    "Issue #": 10,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Kerry Drake Detective cases",
    "Issue #": 12,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Kerry Drake Detective cases",
    "Issue #": 28,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Kid Colt Outlaw",
    "Issue #": 33,
    "Condition": "VG-",
    "Website Notes": "Black Rider",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Kid Colt Outlaw",
    "Issue #": 72,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 50,
    "": "30th Century"
  },
  {
    "Title": "Kid Eternity",
    "Issue #": 1,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 110,
    "": "Gilligans"
  },
  {
    "Title": "Kilroys",
    "Issue #": 16,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 10,
    "": "Rapid City"
  },
  {
    "Title": "Kilroys",
    "Issue #": 23,
    "Condition": "F/VF",
    "Website Notes": "GGA",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 20,
    "": "Rapid City"
  },
  {
    "Title": "King Comics",
    "Issue #": 87,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 10,
    "": "Gilligans"
  },
  {
    "Title": "Knockout Adventures",
    "Issue #": 1,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Knockout Adventures",
    "Issue #": 1,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Lars of Mars",
    "Issue #": 10,
    "Condition": "VG+",
    "Website Notes": "Robot Cvr",
    "Personal Notes (Not on website)": "Ziff-Davis",
    "Cost Basis": 50,
    "": "Gilligans"
  },
  {
    "Title": "Lash LaRue Western",
    "Issue #": 33,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Lash LaRue Western",
    "Issue #": 45,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Li'l Abner",
    "Issue #": 73,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Little Audrey",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "St John",
    "Cost Basis": 25,
    "": "Rapid City"
  },
  {
    "Title": "Little Eva (3-D)",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "No Glasses",
    "Personal Notes (Not on website)": "St John",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Lone Rider",
    "Issue #": 6,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Farrell",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Lone Rider",
    "Issue #": 10,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Farrell",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Long Bow",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 25,
    "": "CConnect"
  },
  {
    "Title": "Lorna The Jungle Queen",
    "Issue #": 1,
    "Condition": "Poor",
    "Website Notes": "Coverless/1st Wrap Missing",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Lorna The Jungle Queen",
    "Issue #": 2,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Lorna The Jungle Queen",
    "Issue #": 2,
    "Condition": "Poor",
    "Website Notes": "Coverless",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Lorna The Jungle Girl",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": "Heath Cover",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Lorna The Jungle Girl",
    "Issue #": 8,
    "Condition": "Poor",
    "Website Notes": "Coverless",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Lorna The Jungle Girl",
    "Issue #": 10,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Lorna The Jungle Girl",
    "Issue #": 11,
    "Condition": "Poor",
    "Website Notes": "Coverless",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Lorna The Jungle Girl",
    "Issue #": 13,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Lorna The Jungle Girl",
    "Issue #": 16,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Lorna The Jungle Girl",
    "Issue #": 16,
    "Condition": "FA",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Lorna The Jungle Girl",
    "Issue #": 18,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": "Gilligans"
  },
  {
    "Title": "Lorna The Jungle Girl",
    "Issue #": 18,
    "Condition": "FA",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Lorna The Jungle Girl",
    "Issue #": 20,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Lorna The Jungle Girl",
    "Issue #": 22,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Man Comics",
    "Issue #": 10,
    "Condition": "VG/F",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Man in Black",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "Powell Art",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "Man in Black",
    "Issue #": 2,
    "Condition": "FN+",
    "Website Notes": "Powell Art",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "Man in Black",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "Powell Art",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Man in Black",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "Powell Art",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "Man in Black",
    "Issue #": 4,
    "Condition": "FN-",
    "Website Notes": "Powell Art",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "Man O' Mars",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "Whitman Cvr",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 235,
    "": "Heritage"
  },
  {
    "Title": "Marines in Battle",
    "Issue #": 19,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Marvel Family",
    "Issue #": 7,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Marvel Family",
    "Issue #": 18,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Marvel Family",
    "Issue #": 22,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Marvel Family",
    "Issue #": 34,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Marvel Family",
    "Issue #": 35,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Marvel Family",
    "Issue #": 51,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Marvel Family",
    "Issue #": 53,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Marvel Family",
    "Issue #": 75,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Marvel Family",
    "Issue #": 77,
    "Condition": "VG-",
    "Website Notes": "Communist Cvr",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 50,
    "": "Vince"
  },
  {
    "Title": "Marvel Mystery Comics",
    "Issue #": 61,
    "Condition": "GD-",
    "Website Notes": "Schomburg",
    "Personal Notes (Not on website)": "Timely",
    "Cost Basis": 400,
    "": "Todd"
  },
  {
    "Title": "Masked Ranger",
    "Issue #": 2,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Premiere",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Master Comics",
    "Issue #": 85,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Master Comics",
    "Issue #": 89,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Master Comics",
    "Issue #": 92,
    "Condition": "G+",
    "Website Notes": "Space Slavers",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Master Comics",
    "Issue #": 93,
    "Condition": "FA",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Master Comics",
    "Issue #": 102,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Master Comics",
    "Issue #": 131,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Men's Adventures",
    "Issue #": 24,
    "Condition": "G/VG",
    "Website Notes": "Horror",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 155,
    "": ""
  },
  {
    "Title": "Men's Adventures",
    "Issue #": 24,
    "Condition": "CGC 5.0",
    "Website Notes": "Horror",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 155,
    "": ""
  },
  {
    "Title": "Men's Adventures",
    "Issue #": 26,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 130,
    "": "30th Century"
  },
  {
    "Title": "Mike Barnett",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 25,
    "": "Rich G"
  },
  {
    "Title": "Military Comics",
    "Issue #": 37,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Miss America Comics",
    "Issue #": 1,
    "Condition": "CGC 6..5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Timely",
    "Cost Basis": 3200,
    "": ""
  },
  {
    "Title": "Mister Mystery",
    "Issue #": 11,
    "Condition": "G/VG",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "Aragon",
    "Cost Basis": 1175,
    "": "Gilligans"
  },
  {
    "Title": "Modern Comics",
    "Issue #": 61,
    "Condition": "GD+",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Modern Comics",
    "Issue #": 70,
    "Condition": "VG-",
    "Website Notes": "Torchy",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Modern Comics",
    "Issue #": 83,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Modern Comics",
    "Issue #": 86,
    "Condition": "VG-",
    "Website Notes": "Torchy",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Modern Comics",
    "Issue #": 94,
    "Condition": "VG/F",
    "Website Notes": "Torchy",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Modern Comics",
    "Issue #": 95,
    "Condition": "VG+",
    "Website Notes": "Torchy",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Modern Comics",
    "Issue #": 98,
    "Condition": "VG+",
    "Website Notes": "Torchy",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 50,
    "": "Gilligans"
  },
  {
    "Title": "Modern Comics",
    "Issue #": 102,
    "Condition": "G+",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Mopsy",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "St John",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Motion Picture Comics",
    "Issue #": 106,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Movie Love",
    "Issue #": 17,
    "Condition": "FN",
    "Website Notes": "Frazetta",
    "Personal Notes (Not on website)": "Famous Funnies",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "My Own Romance",
    "Issue #": 29,
    "Condition": "VG",
    "Website Notes": "Precode",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Murder Incorporated",
    "Issue #": 5,
    "Condition": "CGC 6.0",
    "Website Notes": "GGA",
    "Personal Notes (Not on website)": "Fox",
    "Cost Basis": 675,
    "": "clink"
  },
  {
    "Title": "My Romantic Adventures",
    "Issue #": 72,
    "Condition": "VG/F",
    "Website Notes": "1st Issue",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Mystery Tales",
    "Issue #": 1,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 250,
    "": "PBA"
  },
  {
    "Title": "Mystery Tales",
    "Issue #": 8,
    "Condition": "VG",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 240,
    "": "CConnect"
  },
  {
    "Title": "Mystery Tales",
    "Issue #": 24,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 90,
    "": ""
  },
  {
    "Title": "Mystery Tales",
    "Issue #": 35,
    "Condition": "VG+",
    "Website Notes": "Everett",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mystery Tales",
    "Issue #": 35,
    "Condition": "FN-",
    "Website Notes": "Everett",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 100,
    "": "TTreasures"
  },
  {
    "Title": "Mystery Tales",
    "Issue #": 51,
    "Condition": "F/G",
    "Website Notes": "Everett",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Mystery Tales",
    "Issue #": 54,
    "Condition": "G/VG",
    "Website Notes": "Crandall",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Mystic",
    "Issue #": 22,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 100,
    "": "Rich G"
  },
  {
    "Title": "Mystic",
    "Issue #": 30,
    "Condition": "CGC 4.5",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 360,
    "": "comicconnect"
  },
  {
    "Title": "Mystic",
    "Issue #": 36,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 100,
    "": "30th Century"
  },
  {
    "Title": "Mystic",
    "Issue #": 36,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 120,
    "": "30th century"
  },
  {
    "Title": "Mystic",
    "Issue #": 39,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": "Kent ref"
  },
  {
    "Title": "Mystic",
    "Issue #": 47,
    "Condition": "P",
    "Website Notes": "No Back Cover",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 5,
    "": "Trade"
  },
  {
    "Title": "Mystic",
    "Issue #": 53,
    "Condition": "GD",
    "Website Notes": "Everett Cover",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": "GFalls"
  },
  {
    "Title": "Mystical Tales",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Navy Action",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Nellie the Nurse",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "De Carlo 1957",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 700,
    "": "TTreasures"
  },
  {
    "Title": "Nyoka",
    "Issue #": 3,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Nyoka",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "Bondage Cover",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Nyoka",
    "Issue #": 6,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Nyoka",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": "Bondage Cover",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Nyoka",
    "Issue #": 14,
    "Condition": "G",
    "Website Notes": "Bondage Cover",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Nyoka",
    "Issue #": 24,
    "Condition": "G/VG",
    "Website Notes": "Bondage Cover",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Nyoka",
    "Issue #": 43,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Nyoka",
    "Issue #": 63,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Nyoka",
    "Issue #": 64,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Nyoka",
    "Issue #": 76,
    "Condition": "F/VF",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Nyoka",
    "Issue #": 77,
    "Condition": "F/VF",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Nyoka",
    "Issue #": 77,
    "Condition": "VG/F",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Operation Peril",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Out of the Night",
    "Issue #": 16,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 85,
    "": "heritage"
  },
  {
    "Title": "Out of the Shadows",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Standard",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Patsy and Hedy",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 180,
    "": ""
  },
  {
    "Title": "Patsy and Hedy",
    "Issue #": 27,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 50,
    "": "30th Century"
  },
  {
    "Title": "Patsy and Hedy",
    "Issue #": 32,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 50,
    "": "30th Century"
  },
  {
    "Title": "Patsy and Hedy",
    "Issue #": 84,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Patsy and her Pals",
    "Issue #": 1,
    "Condition": "CGC 8.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 440,
    "": "clink"
  },
  {
    "Title": "Patsy and her Pals",
    "Issue #": 11,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 40,
    "": "30th Century"
  },
  {
    "Title": "Patsy and her Pals",
    "Issue #": 26,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": "Gilligans"
  },
  {
    "Title": "Patsy Walker",
    "Issue #": 12,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": "Gilligans"
  },
  {
    "Title": "Patsy Walker",
    "Issue #": 31,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 26,
    "": "30th Century"
  },
  {
    "Title": "Patsy Walker",
    "Issue #": 58,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": "30th Century"
  },
  {
    "Title": "Patsy Walker",
    "Issue #": 61,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": "30th Century"
  },
  {
    "Title": "Patsy Walker",
    "Issue #": 62,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": "30th Century"
  },
  {
    "Title": "Pay-Off",
    "Issue #": 3,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "DS",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Perfect Crime",
    "Issue #": 23,
    "Condition": "CGC 1.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Story",
    "Cost Basis": 100,
    "": "RapidCity"
  },
  {
    "Title": "Personal Love",
    "Issue #": 28,
    "Condition": "VG-",
    "Website Notes": "Frazetta Story",
    "Personal Notes (Not on website)": "Famous Funnies",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Pirates Comics",
    "Issue #": 4,
    "Condition": "G+",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Planet  ",
    "Issue #": "V4 #5",
    "Condition": "VG/F",
    "Website Notes": "Pulp",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Planet Comics",
    "Issue #": 46,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 110,
    "": ""
  },
  {
    "Title": "Planet Comics",
    "Issue #": 49,
    "Condition": "G/VG",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 100,
    "": "Chris Frohwirth"
  },
  {
    "Title": "Planet Comics",
    "Issue #": 55,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 110,
    "": ""
  },
  {
    "Title": "Planet Comics",
    "Issue #": 71,
    "Condition": "CGC 3.0",
    "Website Notes": "Canadian",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 150,
    "": "George"
  },
  {
    "Title": "Plastic Man",
    "Issue #": 33,
    "Condition": "PGX 5.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 175,
    "": "TTreasures"
  },
  {
    "Title": "Plastic Man",
    "Issue #": 36,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 110,
    "": ""
  },
  {
    "Title": "Plastic Man",
    "Issue #": 64,
    "Condition": "VG/F",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 100,
    "": "Brian"
  },
  {
    "Title": "Police Action",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Police Comics",
    "Issue #": 55,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 30,
    "": "Gilligans"
  },
  {
    "Title": "Police Comics",
    "Issue #": 106,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 100,
    "": "Gilligans"
  },
  {
    "Title": "Police Comics",
    "Issue #": 113,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Police Comics",
    "Issue #": 125,
    "Condition": "VG",
    "Website Notes": "Bondage Cover",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Poppo",
    "Issue #": 2,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lev Gleason",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Popular Comics",
    "Issue #": 17,
    "Condition": "VG/F",
    "Website Notes": 1937,
    "Personal Notes (Not on website)": "Dell",
    "Cost Basis": 50,
    "": "Gilligans"
  },
  {
    "Title": "Popular Teen-Agers",
    "Issue #": 6,
    "Condition": "VG",
    "Website Notes": "LB Cole",
    "Personal Notes (Not on website)": "Accepted",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Private Eye",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Prize Comics",
    "Issue #": 113,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Prize",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Prize Comics",
    "Issue #": 114,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Prize",
    "Cost Basis": 20,
    "": "CConnect"
  },
  {
    "Title": "Public Enemies",
    "Issue #": 1,
    "Condition": "GD",
    "Website Notes": "GGA",
    "Personal Notes (Not on website)": "Crime",
    "Cost Basis": 40,
    "": "heritage"
  },
  {
    "Title": "Public Enemies",
    "Issue #": 3,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Crime",
    "Cost Basis": 50,
    "": "heritage"
  },
  {
    "Title": "Public Enemies",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Crime",
    "Cost Basis": 50,
    "": "heritage"
  },
  {
    "Title": "Public Enemies",
    "Issue #": 9,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Crime",
    "Cost Basis": 50,
    "": "heritage"
  },
  {
    "Title": "Punch and Judy Comics",
    "Issue #": 1,
    "Condition": "FA",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Race For the Moon",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "Race For the Moon",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "Race For the Moon",
    "Issue #": 3,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "Railroads Deliver the Goods",
    "Issue #": "NN",
    "Condition": "VF",
    "Website Notes": "Giveaway",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Rails Across America",
    "Issue #": "NN",
    "Condition": "VF",
    "Website Notes": "Giveaway",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Ralph Kiner",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 180,
    "": ""
  },
  {
    "Title": "Rangers Comics",
    "Issue #": 18,
    "Condition": "G/VG",
    "Website Notes": "Nazi Cover",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 100,
    "": "Chris Frohwirth"
  },
  {
    "Title": "Rangers Comics",
    "Issue #": 22,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Rangers Comics",
    "Issue #": 23,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Rangers Comics",
    "Issue #": 28,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Rangers Comics",
    "Issue #": 30,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Rangers Comics",
    "Issue #": 31,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Rangers Comics",
    "Issue #": 34,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Rangers Comics",
    "Issue #": 35,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Rangers Comics",
    "Issue #": 35,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Rangers Comics",
    "Issue #": 36,
    "Condition": "VG",
    "Website Notes": "Baker Art",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 100,
    "": "BCC"
  },
  {
    "Title": "Rangers Comics",
    "Issue #": 46,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Rawhide Kid",
    "Issue #": 11,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Rawhide Kid",
    "Issue #": 22,
    "Condition": "CGC 4.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Real Clue",
    "Issue #": "V7#6",
    "Condition": "VG/F",
    "Website Notes": "Frazetta",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 25,
    "": "Rich G"
  },
  {
    "Title": "Real Heroes",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "Lou Gehrig C/Sty",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Real Life Comics",
    "Issue #": 5,
    "Condition": "CGC 6.0",
    "Website Notes": "Schomburg",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 325,
    "": ""
  },
  {
    "Title": "Red Circle Comics",
    "Issue #": 4,
    "Condition": "FA",
    "Website Notes": "Venus Story",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Red Warrior",
    "Issue #": 2,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Reno Browne",
    "Issue #": 51,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": "Gilligans"
  },
  {
    "Title": "Return of the Outlaw",
    "Issue #": 3,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Minoan",
    "Cost Basis": 10,
    "": "Dahlgren"
  },
  {
    "Title": "Robin Hood Tales",
    "Issue #": 4,
    "Condition": "G/VG",
    "Website Notes": "Baker C/A",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 10,
    "": "Charlottesville"
  },
  {
    "Title": "Rocket Kelly",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Rocket Kelly",
    "Issue #": 3,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 10,
    "": "Todd"
  },
  {
    "Title": "Romantic Love",
    "Issue #": 5,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Avon",
    "Cost Basis": 50,
    "": "2023 BCC"
  },
  {
    "Title": "Rugged Action",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Rulah",
    "Issue #": 18,
    "Condition": "VG",
    "Website Notes": "Kamen Art",
    "Personal Notes (Not on website)": "Fox",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Rulah",
    "Issue #": 20,
    "Condition": "VG",
    "Website Notes": "Kamen Art",
    "Personal Notes (Not on website)": "Fox",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Rulah",
    "Issue #": 25,
    "Condition": "FA",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fox",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Samson",
    "Issue #": 14,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Farrell",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Science Comics",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "A-Bomb Cvr 1946",
    "Personal Notes (Not on website)": "Realistic",
    "Cost Basis": 40,
    "": "Gilligans"
  },
  {
    "Title": "Science Comics",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "1951 Man on the Moon",
    "Personal Notes (Not on website)": "Science Ill",
    "Cost Basis": 40,
    "": "Gilligans"
  },
  {
    "Title": "Secret Loves",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Ward Cover",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 180,
    "": "Heritage"
  },
  {
    "Title": "Sheena",
    "Issue #": 16,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 60,
    "": "Holder"
  },
  {
    "Title": "Sheena 3D",
    "Issue #": "nn",
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 50,
    "": "Gilligans"
  },
  {
    "Title": "Sherry the Showgirl",
    "Issue #": 7,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Single Series",
    "Issue #": 4,
    "Condition": "CGC 5.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "United Features",
    "Cost Basis": 92,
    "": "Pedigree"
  },
  {
    "Title": "Soldier Comics",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 20,
    "": "George"
  },
  {
    "Title": "Soldiers of Fortune",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 20,
    "": "TTreasures"
  },
  {
    "Title": "Spaceman",
    "Issue #": 3,
    "Condition": "P/F",
    "Website Notes": "1 Non Story Pg Out",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 100,
    "": "TTreasures"
  },
  {
    "Title": "Spaceman",
    "Issue #": 4,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 100,
    "": "TTreasures"
  },
  {
    "Title": "Spaceman",
    "Issue #": 4,
    "Condition": "FA",
    "Website Notes": "Split Spine",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": "GFalls"
  },
  {
    "Title": "Spectacular Stories Magazine",
    "Issue #": 4,
    "Condition": "GD",
    "Website Notes": "GGA",
    "Personal Notes (Not on website)": "Fox",
    "Cost Basis": 50,
    "": "Todd"
  },
  {
    "Title": "Spellbound",
    "Issue #": 7,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 350,
    "": ""
  },
  {
    "Title": "Spellbound",
    "Issue #": 30,
    "Condition": "VG-",
    "Website Notes": "Everett Cover",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 60,
    "": "Billings"
  },
  {
    "Title": "Spirit",
    "Issue #": "NN",
    "Condition": "FN",
    "Website Notes": "Tribune insert Lady Luck",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Sports Stars",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Hillman",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Spy Fighters",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Spy Hunters",
    "Issue #": 8,
    "Condition": "FN",
    "Website Notes": "Capitol Cvr",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 50,
    "": "Todd"
  },
  {
    "Title": "Spy Smasher",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": "Japanese War C/S",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 600,
    "": "A-1"
  },
  {
    "Title": "Spy Thrillers",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 55,
    "": "30th Century"
  },
  {
    "Title": "Steve Samson",
    "Issue #": 34,
    "Condition": "VG",
    "Website Notes": "British",
    "Personal Notes (Not on website)": "L. Miller",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Straight Arrow",
    "Issue #": 1,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ME",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Straight Arrow",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ME",
    "Cost Basis": 25,
    "": "CConnect"
  },
  {
    "Title": "Strange Fantasy",
    "Issue #": 9,
    "Condition": "CGC 5.5",
    "Website Notes": "Black Cat Sty",
    "Personal Notes (Not on website)": "Farrell",
    "Cost Basis": 250,
    "": "Joe"
  },
  {
    "Title": "Strange Tales",
    "Issue #": 8,
    "Condition": "CGC 4.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 300,
    "": "Dahlgren"
  },
  {
    "Title": "Strange Tales  ",
    "Issue #": 29,
    "Condition": "CGC 5.0",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 1425,
    "": "Comiclink"
  },
  {
    "Title": "Strange Tales",
    "Issue #": 44,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 30,
    "": "Gilligans"
  },
  {
    "Title": "Strange Tales",
    "Issue #": 58,
    "Condition": "F/G",
    "Website Notes": "Williamson",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 59,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 80,
    "": "Gilligans"
  },
  {
    "Title": "Strange Worlds  ",
    "Issue #": 8,
    "Condition": "CGC 4.5",
    "Website Notes": "Classic Robot Cover",
    "Personal Notes (Not on website)": "Avon",
    "Cost Basis": 700,
    "": "Clink"
  },
  {
    "Title": "Strange Worlds (1958)",
    "Issue #": 1,
    "Condition": "CGC 6.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 315,
    "": ""
  },
  {
    "Title": "Strange Worlds (1958)",
    "Issue #": 1,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 75,
    "": "Kent ref"
  },
  {
    "Title": "Strange Worlds (1958)",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "Williamson",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 80,
    "": "Kent ref"
  },
  {
    "Title": "Stuntman",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Simon Kirby",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 100,
    "": "Gilligans"
  },
  {
    "Title": "Super Magician Comics",
    "Issue #": "V2#9",
    "Condition": "VG",
    "Website Notes": "Red Dragon",
    "Personal Notes (Not on website)": "Street&Smith",
    "Cost Basis": 40,
    "": "Frederick"
  },
  {
    "Title": "Super-Mystery Comics",
    "Issue #": "V1#2",
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Ace",
    "Cost Basis": 900,
    "": "30th Century"
  },
  {
    "Title": "Surprising Adventures",
    "Issue #": 11,
    "Condition": "GD",
    "Website Notes": "Canadian LB Cole Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Suspense",
    "Issue #": 15,
    "Condition": "VG+",
    "Website Notes": "Maneely",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Suspense",
    "Issue #": 21,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 100,
    "": "Trade"
  },
  {
    "Title": "Suspense",
    "Issue #": 24,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 110,
    "": "PBA"
  },
  {
    "Title": "Suspense",
    "Issue #": 27,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Swat Malone",
    "Issue #": "NN",
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Tales of Horror",
    "Issue #": 2,
    "Condition": "CGC 2.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Toby",
    "Cost Basis": 118,
    "": "clink"
  },
  {
    "Title": "Tales of Justice",
    "Issue #": 55,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Tales of Justice",
    "Issue #": 62,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Tales of Justice",
    "Issue #": 65,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Teen-Age Brides",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 50,
    "": "SDCon"
  },
  {
    "Title": "Tell it to the Marines",
    "Issue #": 10,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Toby",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Terrific Comics",
    "Issue #": 2,
    "Condition": "CGC 3.0",
    "Website Notes": "Qualified (staples replaced)",
    "Personal Notes (Not on website)": "Continental",
    "Cost Basis": 400,
    "": ""
  },
  {
    "Title": "Terrifying Tales",
    "Issue #": 14,
    "Condition": "G-",
    "Website Notes": "L Cole Bondage Cvr",
    "Personal Notes (Not on website)": "Star",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Terrors of the Jungle",
    "Issue #": 6,
    "Condition": "G/VG",
    "Website Notes": "LB Cole",
    "Personal Notes (Not on website)": "Star",
    "Cost Basis": 150,
    "": "Beyond"
  },
  {
    "Title": "Terrors of the Jungle",
    "Issue #": 10,
    "Condition": "VG",
    "Website Notes": "L Cole Cvr",
    "Personal Notes (Not on website)": "Star",
    "Cost Basis": 175,
    "": "CConnect"
  },
  {
    "Title": "Terry and the Pirates",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Terry and the Pirates",
    "Issue #": 24,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Terry-Toons",
    "Issue #": 31,
    "Condition": "VG",
    "Website Notes": "CFL",
    "Personal Notes (Not on website)": "Timely",
    "Cost Basis": 10,
    "": "Todd"
  },
  {
    "Title": "Texas Kid",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "Maneely",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": "Tomlinson"
  },
  {
    "Title": "This Magazine is Haunted",
    "Issue #": 4,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 140,
    "": "Joe"
  },
  {
    "Title": "This Magazine is Haunted",
    "Issue #": 9,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 125,
    "": "Beyond"
  },
  {
    "Title": "3-D Comics",
    "Issue #": "Tor",
    "Condition": "G/VG",
    "Website Notes": "w/glasses",
    "Personal Notes (Not on website)": "St John",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "3-D Comics",
    "Issue #": "Tor",
    "Condition": "VG",
    "Website Notes": "3-D Cover No Glasses",
    "Personal Notes (Not on website)": "St John",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Thrill O Rama",
    "Issue #": 3,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Thrills of Tomorrow",
    "Issue #": 17,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Tip Top Comics",
    "Issue #": 62,
    "Condition": "VG",
    "Website Notes": "Tarzan",
    "Personal Notes (Not on website)": "United Features",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Tip Top Comics",
    "Issue #": 82,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "United Features",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tip Top Comics",
    "Issue #": 172,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "United Features",
    "Cost Basis": 5,
    "": "Mike"
  },
  {
    "Title": "T-Man",
    "Issue #": 4,
    "Condition": "FN",
    "Website Notes": "Crandal Cover",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 50,
    "": "Indy"
  },
  {
    "Title": "T-Man",
    "Issue #": 12,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "T-Man",
    "Issue #": 12,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 30,
    "": "Indy"
  },
  {
    "Title": "T-Man",
    "Issue #": 37,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 20,
    "": "Annandale"
  },
  {
    "Title": "Tomb of Terror",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 150,
    "": "TTreasures"
  },
  {
    "Title": "Tomb of Terror",
    "Issue #": 6,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 150,
    "": "TTreasures"
  },
  {
    "Title": "Tom Mix Comics",
    "Issue #": 1,
    "Condition": "CGC 4.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Ralston-Purina",
    "Cost Basis": 102,
    "": "Pedigre"
  },
  {
    "Title": "Tom Mix Western",
    "Issue #": 8,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Top Adventure",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "IW Reprint",
    "Personal Notes (Not on website)": "IW",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "True Aviation Comcs Digest",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Aviation",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "True Love Pictorial",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "Baker C/A Giant",
    "Personal Notes (Not on website)": "St John",
    "Cost Basis": 575,
    "": ""
  },
  {
    "Title": "True Sport Picture Stories",
    "Issue #": "V3#10",
    "Condition": "VG",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "Street Smith",
    "Cost Basis": 100,
    "": "Gilligans"
  },
  {
    "Title": "Two-Gun Kid",
    "Issue #": 29,
    "Condition": "VG",
    "Website Notes": "Maneely",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Uncanny Tales",
    "Issue #": 14,
    "Condition": "FN-",
    "Website Notes": "Heath Art",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 100,
    "": "Joe"
  },
  {
    "Title": "Uncanny Tales",
    "Issue #": 16,
    "Condition": "CGC 5.5",
    "Website Notes": "Zombie Cvr",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 300,
    "": "Dahlgren"
  },
  {
    "Title": "Uncanny Tales",
    "Issue #": 41,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": "GFalls"
  },
  {
    "Title": "Uncle Milty",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "Milton Berle",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 240,
    "": "Gilligans"
  },
  {
    "Title": "Uncle Sam Quarterly",
    "Issue #": 2,
    "Condition": "CGC 3.0",
    "Website Notes": "Slt R",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 200,
    "": ""
  },
  {
    "Title": "Undersea Commandos",
    "Issue #": 3,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Avon",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Underworld Crime",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 100,
    "": "TTReasures"
  },
  {
    "Title": "United States Fighting Air Force",
    "Issue #": 19,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Superior",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "US Paratroopers",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "Extreme Violence",
    "Personal Notes (Not on website)": "Avon",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Venus",
    "Issue #": 16,
    "Condition": "CGC 5.5",
    "Website Notes": "Everett C/A",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 400,
    "": "BCC2025"
  },
  {
    "Title": "Wambi",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wambi",
    "Issue #": 11,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "War Adventures",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "War Adventures",
    "Issue #": 6,
    "Condition": "CGC 6.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 165,
    "": "CConnect"
  },
  {
    "Title": "War Combat",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 125,
    "": " "
  },
  {
    "Title": "Web of Evil",
    "Issue #": 17,
    "Condition": "FA",
    "Website Notes": "Opium Story",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 35,
    "": "Rich G"
  },
  {
    "Title": "Web of Evil",
    "Issue #": 20,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Quality",
    "Cost Basis": 75,
    "": "PBA"
  },
  {
    "Title": "Web of Mystery",
    "Issue #": 13,
    "Condition": "CGC 6.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Ace",
    "Cost Basis": 250,
    "": "lonestar"
  },
  {
    "Title": "Weird Adventures",
    "Issue #": 1,
    "Condition": "CGC 4.0",
    "Website Notes": "Baker Art",
    "Personal Notes (Not on website)": "PL Publishing",
    "Cost Basis": 300,
    "": ""
  },
  {
    "Title": "Weird Adventures",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "PL Publishing",
    "Cost Basis": 300,
    "": "Aftertime"
  },
  {
    "Title": "Weird Mysteries",
    "Issue #": 2,
    "Condition": "VG",
    "Website Notes": "Bailey",
    "Personal Notes (Not on website)": "Gilmour",
    "Cost Basis": 1000,
    "": "Joe"
  },
  {
    "Title": "Weird Mysteries",
    "Issue #": 8,
    "Condition": "G/VG",
    "Website Notes": "Wolverton",
    "Personal Notes (Not on website)": "Gilmour",
    "Cost Basis": 200,
    "": ""
  },
  {
    "Title": "Weird Mysteries",
    "Issue #": 11,
    "Condition": "G/VG",
    "Website Notes": "Bailey",
    "Personal Notes (Not on website)": "Gilmour",
    "Cost Basis": 300,
    "": ""
  },
  {
    "Title": "Western Crime Busters",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Trojan",
    "Cost Basis": 70,
    "": ""
  },
  {
    "Title": "Western Kid",
    "Issue #": 9,
    "Condition": "VG/F",
    "Website Notes": "Williamson",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Western Kid",
    "Issue #": 14,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 30,
    "": "30th Century"
  },
  {
    "Title": "Western Kid",
    "Issue #": 15,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 30,
    "": "30th Century"
  },
  {
    "Title": "Western Outlaws",
    "Issue #": 64,
    "Condition": "GD",
    "Website Notes": "CFO ow VG",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Whack",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "3-D Comics w/Glasses",
    "Personal Notes (Not on website)": "St John",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "White Indian",
    "Issue #": 11,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ME",
    "Cost Basis": 10,
    "": "Gilligans"
  },
  {
    "Title": "Wild",
    "Issue #": 2,
    "Condition": "GD+",
    "Website Notes": "Witch Cover",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 45,
    "": "trade"
  },
  {
    "Title": "Wild Bill Hickok",
    "Issue #": 20,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Avon",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Wild Boy",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "Saunders Cvr",
    "Personal Notes (Not on website)": "Ziff Davis",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Wild Boy",
    "Issue #": 11,
    "Condition": "VG/F",
    "Website Notes": "Saunders Cvr",
    "Personal Notes (Not on website)": "Ziff Davis",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wild Boy",
    "Issue #": 12,
    "Condition": "VG/F",
    "Website Notes": "Saunders Cvr",
    "Personal Notes (Not on website)": "Ziff Davis",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wild Western",
    "Issue #": 36,
    "Condition": "VG/F",
    "Website Notes": "Maneely Cvr",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 40,
    "": "30th Century"
  },
  {
    "Title": "Wings",
    "Issue #": 8,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Wings",
    "Issue #": 47,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Wings",
    "Issue #": 49,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Wings",
    "Issue #": 79,
    "Condition": "FN+",
    "Website Notes": "Devil Cover",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Wings",
    "Issue #": 85,
    "Condition": "VG/F",
    "Website Notes": "Lubbers GGA",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Wings",
    "Issue #": 89,
    "Condition": "CGC 5.0",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Wings",
    "Issue #": 92,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Wings",
    "Issue #": 94,
    "Condition": "VG/F",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 359,
    "": ""
  },
  {
    "Title": "Wings",
    "Issue #": 95,
    "Condition": "VG/F",
    "Website Notes": "Lubbers GGA",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Wings",
    "Issue #": 96,
    "Condition": "FN",
    "Website Notes": "Lubbers GGA",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Wings",
    "Issue #": 98,
    "Condition": "F/VF",
    "Website Notes": "Lubbers GGA",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Wings",
    "Issue #": 99,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Wings",
    "Issue #": 110,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Wings",
    "Issue #": 123,
    "Condition": "FN+",
    "Website Notes": "Whitman Cover",
    "Personal Notes (Not on website)": "Fiction House",
    "Cost Basis": 150,
    "": "Dahlgren"
  },
  {
    "Title": "Witches' Western Tales",
    "Issue #": 29,
    "Condition": "VG/F",
    "Website Notes": "Precode",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 30,
    "": "Vancouver"
  },
  {
    "Title": "Witches' Western Tales",
    "Issue #": 30,
    "Condition": "VG/F",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 36,
    "": "Vancouver"
  },
  {
    "Title": "Wonder Book of Rubber",
    "Issue #": "NN",
    "Condition": "VF",
    "Website Notes": "1947 Giveaway",
    "Personal Notes (Not on website)": " ",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Wonder Book of Rubber",
    "Issue #": "NN",
    "Condition": "FN",
    "Website Notes": "1947 Giveaway",
    "Personal Notes (Not on website)": " ",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Wonder Comics",
    "Issue #": 9,
    "Condition": "CGC 5.5",
    "Website Notes": "Schomburg Wonderman Begins",
    "Personal Notes (Not on website)": "Better",
    "Cost Basis": 1300,
    "": "Comiclink"
  },
  {
    "Title": "Wonder Comics",
    "Issue #": 14,
    "Condition": "CGC 4.0",
    "Website Notes": "Schomburg",
    "Personal Notes (Not on website)": "Better",
    "Cost Basis": 500,
    "": "Hakes"
  },
  {
    "Title": "Wonderworld Comics",
    "Issue #": 9,
    "Condition": "G/VG",
    "Website Notes": "Lou Fine Cvr",
    "Personal Notes (Not on website)": "Fox",
    "Cost Basis": 300,
    "": "Gilligans"
  },
  {
    "Title": "World of Fantasy",
    "Issue #": 2,
    "Condition": "GD-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "GFalls"
  },
  {
    "Title": "World of Fantasy",
    "Issue #": 17,
    "Condition": "GD",
    "Website Notes": "Ditko/Kirby",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 25,
    "": "Kent ref"
  },
  {
    "Title": "World of Fantasy",
    "Issue #": 19,
    "Condition": "F/G",
    "Website Notes": "Ditko/Kirby",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": "GFalls"
  },
  {
    "Title": "World of Suspense",
    "Issue #": 2,
    "Condition": "CGC 3.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Wow",
    "Issue #": 5,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 100,
    "": "Todd"
  },
  {
    "Title": "Wow",
    "Issue #": 63,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fawcett",
    "Cost Basis": 65,
    "": "Dahlgren"
  },
  {
    "Title": "Wyatt Earp",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "Williamson",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wyatt Earp",
    "Issue #": 20,
    "Condition": "VG/F",
    "Website Notes": "Maneely",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Young Brides",
    "Issue #": "V1#3",
    "Condition": "GD",
    "Website Notes": "Simon Kirby",
    "Personal Notes (Not on website)": "Prize",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Zegra",
    "Issue #": 2,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fox",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Zoot",
    "Issue #": 11,
    "Condition": "CGC 2.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fox",
    "Cost Basis": 500,
    "": "Tim"
  },
  {
    "Title": "Zoot",
    "Issue #": 13,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fox",
    "Cost Basis": 125,
    "": ""
  }
];
